import React, { useState } from "react";
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CameraIcon from '@mui/icons-material/PhotoCamera';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Link as materialLink } from '@mui/material/Link';
import { Link as navLink, useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import { green, red, grey, purple } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { PDFDownloadLink, Link, Document, Page } from 'react-pdf/dist/esm/entry.webpack'
import resumePdf from "./TommasoFrambaResume2023.pdf";



function Copyright() {
  return (
    <Stack
    sx={{ pb: 1 }}
    direction="row"
    spacing={2}
    justifyContent="center"
  >
    {/* <Button variant="contained">Contact</Button> */}
    <Button variant="text" color="custom3" href="https://mail.google.com/mail/?view=cm&fs=1&to=frambatom@gmail.com">Email</Button>
    <Button variant="text" color="custom3" href="https://www.linkedin.com/in/tommaso-framba-a9a7a5199/">LinkedIn</Button>
    <Button variant="text" color="custom3" href="https://github.com/TommasoFramba">Github</Button>
  </Stack>
  );
}

const onDownload = () => {
  const link = document.createElement("a");
  link.download = `TommasoFrambaResume2023.pdf`;
  link.href = "./TommasoFrambaResume2023.pdf";
  link.click();
};


const theme = createTheme({
  palette: {
    text: {
      primary: '#FAFAFA',
      secondary: '#BDBDBD',
    },
    background: {
      default: "#061b2b",
    },
    primary: {
      main: grey[900],
    },
    secondary: {
      main: green[500],
    },
    custom1: {
      light: "#ff6158",
      main: "#e7222e",
      contrastText: "#ffffff",
      dark: "#ac0006",
    },
    custom2: {
      light: "#5284bf",
      main: "#16588e",
      contrastText: "#ffffff",
      dark: "#002f60",
    },
    custom3: {
      light: "#5284bf",
      main: "#4b94cc",
      contrastText: "#ffffff",
      dark: "#002f60",
    }
  },
  neutral: {
    main: '#64748B',
    contrastText: '#fff',
  },
});

export default function Resume() {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main>
        {/* Hero unit */}
        <Typography
        sx={{
          pt: 6,
          pb: 0,
        }}
            variant="h4"
            align="center"
            color="text.primary"
            component="p"
          >
            Resume
          </Typography>
        <Box 
        display="flex" 
        alignItems="center"
        justifyContent="center"
        
        sx={{
          pt: 2,
          pb: 3,
          '&:hover': {
            opacity: [0.9, 0.8, 0.7],
          },
        }}
      >
        
          <div>
            <Document
            onClick={onDownload}
              file={resumePdf}
              onLoadSuccess={onDocumentLoadSuccess}
            >
              
              <Page pageNumber={1}
               />
            </Document></div>
            </Box>
          


          

          










      </main>
      <Box sx={{ bgcolor: 'primary', p: 6 }} component="footer">
        <Typography variant="h6" align="center" gutterBottom>
          Contact
        </Typography>
        
        <Copyright />
        <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <materialLink color="inherit" href="https://github.com/TommasoFramba">
        Tommaso Framba
      </materialLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
      </Box>
      {/* End footer */}
    </ThemeProvider>
  );
}